import { apiClient } from '../api/apiClient';

export const blogService = {
    getPost(postId) {
        return apiClient.get(`blog/${postId}`);
    },

    getMemberPosts(page, pageSize, category) {
        const categoryParam = category ? `&category=${encodeURIComponent(category)}` : '';
        return apiClient.get(`blog/members?page=${page}&pageSize=${pageSize}${categoryParam}`);
    },

    getPublicPosts(page, pageSize, category) {
        const categoryParam = category ? `&category=${encodeURIComponent(category)}` : '';
        return apiClient.get(`blog/public?page=${page}&pageSize=${pageSize}${categoryParam}`);
    },

    getFeaturedPosts(count = 3) {
        return apiClient.get(`blog/featured?count=${count}`);
    },

    getCategories() {
        return apiClient.get('blog/categories');
    },

    getAdminPosts() {
        return apiClient.get('blog/admin/all');
    },

    getMyPosts() {
        return apiClient.get('blog/my-posts');
    },

    createPost(payload) {
        return apiClient.post('blog', {
            json: payload
        });
    },

    uploadImage(formData) {
        return apiClient.post('blog/upload-image', {
            body: formData
        });
    },

    uploadImages(formData) {
        return apiClient.post('blog/upload-images', {
            body: formData
        });
    },

    updatePost(postId, payload) {
        return apiClient.put(`blog/${postId}`, {
            json: payload
        });
    },

    deletePost(postId) {
        return apiClient.del(`blog/${postId}`);
    },

    getPublicPost(slug) {
        return apiClient.get(`blog/public/${slug}`);
    },

    likePost(postId) {
        return apiClient.post(`blog/${postId}/like`);
    }
};
